import * as React from "react";

import { cn } from "lib/utils";
import { CopyButton } from "js/components/ui/copy-button";

function DescriptionList({
  className,
  ...props
}: React.ComponentProps<"dl">) {
  return (
    <dl
      data-slot="description-list"
      className={cn(
        "grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2",
        className,
      )}
      {...props}
    />
  );
}

function DescriptionItem({
  label,
  copyable = false,
  className,
  children,
  ...props
}: {
  label: string;
  copyable?: boolean;
} & React.ComponentProps<"div">) {
  const isEmpty = children == null || children === "";
  const copyValue =
    copyable && !isEmpty && typeof children === "string" ? children : undefined;

  return (
    <div data-slot="description-item" className={cn("space-y-1", className)} {...props}>
      <dt className="text-sm text-muted-foreground" data-sentry-unmask>
        {label}
      </dt>
      <dd className="sentry-mask flex items-center gap-1 text-sm font-medium">
        {isEmpty ? (
          <span className="italic text-muted-foreground">Sin datos</span>
        ) : (
          <>
            <span>{children}</span>
            {copyValue && <CopyButton value={copyValue} />}
          </>
        )}
      </dd>
    </div>
  );
}

export { DescriptionList, DescriptionItem };
